module.exports = __webpack_public_path__ + "static/media/base-64-encoding-algorithm.84c5d69e.84c5d69e.md";